// @ts-nocheck

export const getBetRadarTournamentId = (srTournamentId) => {
  const srTournamentIdStr = srTournamentId || '';
  const betRadarTournamentId = parseInt(srTournamentIdStr.replace('sr:tournament:', ''), 10);
  return isNaN(betRadarTournamentId) ? null : betRadarTournamentId;
};

export const getBetRadarSeasonId = (srSeasonId) => {
  const srSeasonIdStr = srSeasonId || '';
  const betRadarSeasonId = parseInt(srSeasonIdStr.replace('sr:season:', ''), 10);
  return isNaN(betRadarSeasonId) ? null : betRadarSeasonId;
};
